import SectionHeader from '../../components/ui/section-header'
import { useProposalsSocket } from '../../hooks/socket/use-proposals-socket';
import SearchFilterBar from '../../components/ui/search-filter-bar';
import Pagination from '../../components/ui/pagination';
import ProposalTHead from '../../components/ui/proposal-thead';
import ProposalListTBody from '../../components/module/proposal-status/proposal-list-tbody';
import PolicyDataPageModal from '../../components/module/policy-creation/modal/policy-data-page-modal';
import ProposalDetails from '../../components/module/proposal-status/modal/proposal-details';
import ProposalActionModal from '../../components/module/proposal-status/modal/preview-proposal/proposal-action-modal';
import { useBookedProposal } from '../../hooks/proposal/user-booked-proposal';
import { proposalHeaderData } from '../../constant/gms-constant';
import { usePolicyDataState } from '../../hooks/policy/use-policy-data-state';
import { useFilesActions } from '../../hooks/actions/use-files-actions';
import { useModalAccess } from '../../components/global/modal/use-modal-access';

export default function PolicyCreationPage() {
    
    const {
        isShowProposalDetails,
        isShowActionProposalModal
    } = useModalAccess()
    const { handleViewProposal } = useFilesActions();
    const { isPolicyDataPageGCLIP } = usePolicyDataState()

    const {
        normalizedOptions,
        errorMessage,
        searchType,
        setSearchType,
        searchValue,
        setSearchValue,
        setPage,
        pagedData,
        loading,
        isErrorBookedProposals,
        handleReload,
        bookedProposals,
        defaultTotalPages,
        proposalDefaultPageSize,
        handleChangePageSize,
    } = useBookedProposal();
    useProposalsSocket();

    const tHeads:string[] = [
        proposalHeaderData.proposalStatus.label,
        proposalHeaderData.policyStatus.label,
        proposalHeaderData.policyNumber.label,
        proposalHeaderData.effectiveDate.label,
        proposalHeaderData.proposalAs.label,
        proposalHeaderData.groupName.label,
        proposalHeaderData.proposalType.label,
        proposalHeaderData.product.label,
        // proposalHeaderData.email.label,
        proposalHeaderData.preparedBy.label,
    ]

    return (
        <div className="flex h-full min-h-0 w-full flex-col bg-[#f8fafc] rounded-xl border border-gray-200">
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                <SectionHeader
                    title='Policy Creation'
                    subtitle='Review booked proposals and proceed with policy creation.'
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M7 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 7h6M9 11h6M9 15h4" />
                        </svg>
                    }
                />
                <div className="mx-auto flex min-h-0 w-full flex-1 flex-col gap-2">
                    <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-white shadow-sm">
                        <div className="shrink-0 border-b border-gray-200 p-3">
                            <SearchFilterBar
                                searchType={searchType}
                                setSearchType={setSearchType}
                                searchValue={searchValue}
                                setSearchValue={setSearchValue}
                                options={normalizedOptions}
                            />
                        </div>
                        {bookedProposals?.pagination && (
                            <div className="shrink-0 border-b border-gray-200 bg-gray-50/60 p-3">
                                <Pagination
                                    setPage={setPage}
                                    handleReload={handleReload}
                                    pagination={bookedProposals.pagination}
                                    defaultTotalPages={defaultTotalPages}
                                    setDefaultTotalPages={handleChangePageSize}
                                    totalPagesOptions={proposalDefaultPageSize}
                                />
                            </div>
                        )}
                        <div className="min-h-0 flex-1 overflow-auto">
                            <table className="min-w-max w-full border-collapse">
                                <ProposalTHead headers={tHeads}/>
                                <ProposalListTBody
                                    headers={tHeads}
                                    typeOfIcon="update"
                                    isLoadingGetProposal={loading}
                                    isErrorGetProposal={isErrorBookedProposals}
                                    errorMessage={errorMessage}
                                    getProposal={pagedData}
                                    handleEdit={handleViewProposal}
                                />
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {isShowActionProposalModal && ( <ProposalActionModal typeOfIcon='update'/> )}
            {isShowProposalDetails && ( <ProposalDetails /> )}
            {isPolicyDataPageGCLIP && <PolicyDataPageModal/>}
        </div>
    )
}
